import { ThunkAction } from 'redux-thunk'
import apiRest from '../../services/apiRest'
import { StoreState } from '..'
import { PatrimonyAction, PatrimonyActionTypes } from './patrimonyTypes'
import errorHandler from '../../errorHandler'
import { addSnackbar } from 'store/snacks/snacksActions'
import { Action } from 'redux'

export default function getPatrimony(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  PatrimonyAction
> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState
      const { dateTo, dateFrom } = getState().patrimonyState.filters
      const { filterPatrimony } = getState().patrimonyState
      const churchId = user?.churches?.[selectedChurchIndex]?.id
      dispatch({
        type: PatrimonyActionTypes.GET_PATRIMONY_START,
      })

      const { data: patrimony } = await apiRest({
        method: 'get',
        url: '/asset',
        params: {
          churchId,
          dateTo,
          dateFrom,
          filterPatrimony,
        },
      })

      dispatch({
        type: PatrimonyActionTypes.GET_PATRIMONY_SUCCESS,
        patrimony: patrimony,
      })
    } catch (error) {
      errorHandler(error)
      dispatch({ type: PatrimonyActionTypes.GET_PATRIMONY_ERROR })
    }
  }
}

export function editingStartPatrimony(selectedIndex?: number): PatrimonyAction {
  return {
    type: PatrimonyActionTypes.EDITING_START,
    index: selectedIndex,
  }
}

export function savePatrimony(
  form: any
): ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { patrimony, selectedIndex } = getState().patrimonyState
      const { selectedChurchIndex, user } = getState().sessionState
      const churchId = user?.churches?.[selectedChurchIndex]?.id
      if (!churchId) {
        throw new Error()
      }

      Object.assign(form, {
        acquisition_value: parseFloat(
          form.value.replace('R$ ', '').replace('.', '').replace(',', '.')
        ),
        acquisition_date: form.date,
      })

      delete form.value
      delete form.date

      dispatch({ type: PatrimonyActionTypes.SAVE_PATRIMONY_START })
      const patrimonyOrig = selectedIndex !== null && patrimony[selectedIndex]

      await apiRest({
        method: patrimonyOrig ? 'PATCH' : 'POST',
        url: `/asset/${patrimonyOrig ? patrimonyOrig.id : ''}`,
        params: { churchId },
        data: form,
      })

      dispatch({ type: PatrimonyActionTypes.SAVE_PATRIMONY_SUCCESS })
      dispatch(
        addSnackbar('Registro salvo com sucesso', { variant: 'success' })
      )
      dispatch(getPatrimony())
    } catch (error) {
      errorHandler(error)
      dispatch({ type: PatrimonyActionTypes.SAVE_PATRIMONY_ERROR })
      dispatch(
        addSnackbar('Houve um problema. Tente mais tarde.', {
          variant: 'error',
        })
      )
    }
  }
}

export function removePatrimony(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  Action
> {
  return async (dispatch, getState) => {
    try {
      const { patrimony, selectedIndex } = getState().patrimonyState
      const { selectedChurchIndex, user } = getState().sessionState
      const churchId = user?.churches?.[selectedChurchIndex]?.id
      if (!churchId) {
        throw new Error()
      }

      dispatch({ type: PatrimonyActionTypes.REMOVE_PATRIMONY_START })

      const patrimonyOrig = selectedIndex !== null && patrimony[selectedIndex]
      if (!patrimonyOrig) {
        throw new Error()
      }

      await apiRest({
        method: 'DELETE',
        url: `/asset/${patrimonyOrig.id}`,
        params: { churchId },
      })
      dispatch({ type: PatrimonyActionTypes.REMOVE_PATRIMONY_SUCCESS })
      dispatch(
        addSnackbar('Registro removido com sucesso', { variant: 'success' })
      )
      dispatch(getPatrimony())
    } catch (e) {
      dispatch(
        addSnackbar('Houve um problema. Tente mais tarde.', {
          variant: 'error',
        })
      )
      dispatch({ type: PatrimonyActionTypes.REMOVE_PATRIMONY_ERROR })
    }
  }
}

export function setFilters(dateTo: string, dateFrom: string): PatrimonyAction {
  return {
    type: PatrimonyActionTypes.SET_FILTERS,
    filters: { dateTo, dateFrom },
  }
}
